import { Component } from '@angular/core';

import { BaseIconComponent } from '../base-icon.component';

@Component({
  selector: 'app-business-accident-insurance-icon',
  template: `
    <svg
      [attr.width]="width"
      [attr.height]="height"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_522_2351)">
        <path
          d="M8.993 2.371L21.726 15.105C22.1681 15.5381 22.5199 16.0546 22.7611 16.6245C23.0024 17.1945 23.1282 17.8066 23.1314 18.4254C23.1346 19.0443 23.015 19.6577 22.7796 20.2301C22.5443 20.8025 22.1977 21.3225 21.7601 21.7601C21.3225 22.1977 20.8025 22.5442 20.2301 22.7796C19.6577 23.015 19.0443 23.1345 18.4254 23.1314C17.8066 23.1282 17.1945 23.0024 16.6245 22.7611C16.0546 22.5199 15.5381 22.1681 15.105 21.726L2.371 8.993C1.49287 8.11487 0.999542 6.92387 0.999542 5.682C0.999542 4.44013 1.49287 3.24913 2.371 2.371C3.24914 1.49287 4.44014 0.999539 5.682 0.999539C6.92387 0.999539 8.11487 1.49287 8.993 2.371Z"
          [attr.stroke]="color"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M13.5769 6.95571L6.95557 13.5771L10.5208 17.1423L17.1421 10.5209L13.5769 6.95571Z"
          [attr.stroke]="color"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M15.835 17.342C15.8002 17.3071 15.7588 17.2794 15.7132 17.2605C15.6677 17.2416 15.6188 17.2318 15.5695 17.2318C15.5202 17.2318 15.4713 17.2416 15.4258 17.2605C15.3802 17.2794 15.3388 17.3071 15.304 17.342"
          [attr.stroke]="color"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M15.835 17.872C15.9052 17.8017 15.9447 17.7064 15.9447 17.607C15.9447 17.5076 15.9052 17.4123 15.835 17.342"
          [attr.stroke]="color"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M15.3 17.872C15.3706 17.942 15.466 17.9813 15.5655 17.9813C15.665 17.9813 15.7604 17.942 15.831 17.872"
          [attr.stroke]="color"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M15.3 17.342C15.2298 17.4123 15.1903 17.5076 15.1903 17.607C15.1903 17.7064 15.2298 17.8017 15.3 17.872"
          [attr.stroke]="color"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M19.909 17.342C19.8742 17.3071 19.833 17.2794 19.7875 17.2605C19.742 17.2416 19.6932 17.2319 19.644 17.2319C19.5948 17.2319 19.546 17.2416 19.5005 17.2605C19.455 17.2794 19.4137 17.3071 19.379 17.342"
          [attr.stroke]="color"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M19.909 17.872C19.9439 17.8373 19.9716 17.796 19.9905 17.7505C20.0094 17.705 20.0191 17.6562 20.0191 17.607C20.0191 17.5578 20.0094 17.509 19.9905 17.4635C19.9716 17.418 19.9439 17.3767 19.909 17.342"
          [attr.stroke]="color"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M19.379 17.872C19.4493 17.9422 19.5446 17.9817 19.644 17.9817C19.7434 17.9817 19.8387 17.9422 19.909 17.872"
          [attr.stroke]="color"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M19.379 17.342C19.3441 17.3767 19.3164 17.418 19.2975 17.4635C19.2786 17.509 19.2689 17.5578 19.2689 17.607C19.2689 17.6562 19.2786 17.705 19.2975 17.7505C19.3164 17.796 19.3441 17.8373 19.379 17.872"
          [attr.stroke]="color"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M4.629 6.136C4.55869 6.06577 4.46337 6.02633 4.364 6.02633C4.26462 6.02633 4.16931 6.06577 4.099 6.136"
          [attr.stroke]="color"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M4.629 6.667C4.66392 6.63217 4.69163 6.59078 4.71053 6.54522C4.72944 6.49967 4.73917 6.45083 4.73917 6.4015C4.73917 6.35217 4.72944 6.30333 4.71053 6.25777C4.69163 6.21222 4.66392 6.17083 4.629 6.136"
          [attr.stroke]="color"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M4.10001 6.667C4.17032 6.73723 4.26563 6.77667 4.36501 6.77667C4.46438 6.77667 4.55969 6.73723 4.63001 6.667"
          [attr.stroke]="color"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M4.09999 6.136C4.06507 6.17083 4.03736 6.21222 4.01846 6.25777C3.99955 6.30333 3.98982 6.35217 3.98982 6.4015C3.98982 6.45083 3.99955 6.49967 4.01846 6.54522C4.03736 6.59078 4.06507 6.63217 4.09999 6.667"
          stroke="#00D5D3"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M8.7 6.136C8.62969 6.06577 8.53437 6.02633 8.435 6.02633C8.33562 6.02633 8.24031 6.06577 8.17 6.136"
          [attr.stroke]="color"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M8.7 6.667C8.77004 6.59639 8.80934 6.50096 8.80934 6.4015C8.80934 6.30204 8.77004 6.20661 8.7 6.136"
          [attr.stroke]="color"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M8.174 6.667C8.24431 6.73723 8.33962 6.77667 8.439 6.77667C8.53837 6.77667 8.63368 6.73723 8.704 6.667"
          [attr.stroke]="color"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M8.174 6.136C8.13908 6.17083 8.11137 6.21222 8.09246 6.25777C8.07356 6.30333 8.06383 6.35217 8.06383 6.4015C8.06383 6.45083 8.07356 6.49967 8.09246 6.54522C8.11137 6.59078 8.13908 6.63217 8.174 6.667"
          stroke="#00D5D3"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_522_2351">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  `,
})
export class BusinessAccidentInsuranceIconComponent extends BaseIconComponent {}
